import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicMarketCartDetailsParamsRawI,
	type LWApiPublicMarketCartDetailsResultRawI,
} from '@liquidweb-dev/club-sauce/public/market/cart/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const MARKET_CART_DETAILS_QUERY_KEY = '/market/cart/details';

const useCartDetails = (
	params: LWApiPublicMarketCartDetailsParamsRawI,
	options?: UseQueryOptions<LWApiPublicMarketCartDetailsResultRawI, ApiErrorI>,
) =>
	useQuery({
		queryKey: [MARKET_CART_DETAILS_QUERY_KEY, params],
		queryFn: () => api.market.cart.apiRaw.details(params),
		...options,
	});

export default useCartDetails;
